<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Lista Tabelle</v-toolbar-title>
      <v-spacer v-if="tabelle.length > 1"></v-spacer>
      <v-col cols="5" v-if="tabelle.length > 1">
        <v-text-field
          solo
          hide-details
          dense
          label="Cerca la tabella"
          prepend-icon="mdi-table"
          v-model="filtra_lista_tabelle"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="from_adapter_list === true"
            @click="aggiungiTabellaCustom"
            class="mr"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Nuova Tabella</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="from_adapter_list === false"
            @click="goBack"
            class="mr"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table
      v-if="tabelle.length > 1 || from_adapter_list === true"
      :headers="
        from_adapter_list
          ? headers_lista_tabelle_from_adapter
          : headers_lista_tabelle
      "
      :items="
        filtra_lista_tabelle != ''
          ? tabelle.filter((tab) => tab.titolo.includes(filtra_lista_tabelle))
          : tabelle
      "
      height="70vh"
    >
      <template v-slot:[`item.dettaglio`]="{ item }">
        <v-btn @click="dettagliotabella(item)" small>
          <v-icon color="primary">mdi-magnify</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.modifica`]="{ item }">
        <v-btn @click="modificaTabella(item)" small>
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.elimina`]="{ item }">
        <v-btn @click="eliminaTabella(item)" small>
          <v-icon color="error">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Se esiste solo una tabella la visualizzo direttamente -->
    <v-container v-else>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Tabella: {{ tabella_sel.titolo }}</v-toolbar-title
        >
      </v-toolbar>
      <v-data-table :headers="tabella_sel.colonne" :items="result_query">
      </v-data-table>
    </v-container>

    <!-- Dialog Dettaglio Tabella  -->
    <v-dialog v-model="visualizza_dettaglio_tabella" width="unset">
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Tabella: {{ tabella_sel.titolo }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="chiudiDialogDettaglio"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
              small
              light
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table :headers="tabella_sel.colonne" :items="result_query">
      </v-data-table>
    </v-dialog>
    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay -->
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </v-card>
</template>
<script>
import TabellaCustomClass from "@/classes/TabellaCustomClass.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "PlantPlantAdapter",
  components: { SnackbarQV },
  props: {
    from_adapter_list: {
      type: Boolean,
      default: false,
    },
    workorder: {
      type: Object,
      default: () => {},
    },
    lista_tabelle: {
      type: Array,
      default: () => [],
    },
    modulo: {
      type: String,
      default: "",
    },
    visualizza_dialog_tabella_custom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      filtra_lista_tabelle: "",
      // Modal
      query_sel: null,
      overlay: false,
      result_query: [],
      tabella_sel: new TabellaCustomClass(),
      visualizza_dettaglio_tabella: false,
      // Array

      tabelle: [],
      headers_lista_tabelle_from_adapter: [
        {
          value: "modifica",
          text: "Modifica",
          sortable: false,
        },
        { text: "Titolo", value: "titolo" },
        { text: "Modulo", value: "modulo" },
        { text: "Data Creazione", value: "date_ins" },
        { text: "Data Modifica", value: "date_mod" },
        {
          value: "elimina",
          text: "Elimina",
          sortable: false,
        },
      ],
      headers_lista_tabelle: [
        {
          value: "dettaglio",
          text: "Dettaglio",
          sortable: false,
        },
        { text: "Titolo", value: "titolo" },
      ],
    };
  },
  computed: {},
  watch: {
    lista_tabelle: {
      immediate: true,
      handler() {
        this.tabelle = this.lista_tabelle;

        if (this.tabelle.length == 1) {
          this.tabella_sel = this.tabelle[0];
          this.query_sel = this.tabelle[0].query[0];
        }
      },
    },
    visualizza_dialog_tabella_custom: {
      immediate: true,
      handler() {
        if (this.visualizza_dialog_tabella_custom === true) {
          this.getTabella();
        }
      },
    },
  },
  methods: {
    aggiungiTabellaCustom() {
      this.$emit("crea_tabella");
    },
    chiudiDialogDettaglio() {
      this.tabella_sel = new TabellaCustomClass();
      this.visualizza_dettaglio_tabella = false;
    },
    dettagliotabella(item) {
      console.log(item);
      this.tabella_sel = item;
      this.query_sel = item.query[0];
      this.playQuery();
      this.visualizza_dettaglio_tabella = true;
    },
    eliminaTabella(item) {
      item.validita = 0;

      //ricevo tutte le associazioni della tabella
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getqueryassociate",
          token: localStorage.user_token,
          id_query: item.id_query,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        console.log("res getassqueryfromdelete", res);
        if (res.data.asqueries.associativequeries.length > 0 ) {
          let arr_ass = [];

          // setto la validita di ogni associazione a 0 
        res.data.asqueries.associativequeries.forEach(e => {
          e.validita = 0;
          arr_ass.push(e);
        })

          let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryassociate",
          token: localStorage.user_token,
          queryassociate: arr_ass,
          
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200) {
          this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati con successo."
            );
        } else {
           this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server."
            );
        }
      });
        } 
      });

      if (item.colonne.length != 0) {
        item.colonne.forEach((colonna) => {
          colonna.validita = 0;
        });
      }
      if (item.query1.length != 0) {
        item.query1.forEach((query) => {
          query.validita = 0;
        });
      }

      item.query = item.query1;
      delete item.query1;

      this.$emit("elimina_tabella", item);
    },
    getTabella() {
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquerydettaglio",
          token: localStorage.user_token,
          // tipologia: this.tabella_sel.modulo,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.data.result.query.length != 0) {
          this.tabelle = res.data.result.query;

          if (this.tabelle.length <= 1) {
            this.tabella_sel = this.tabelle[0];
            this.query_sel = this.tabelle[0].query1[0];
            this.playQuery();
          }

          console.log(this.tabella_sel);

          this.visualizza_tabella = true;
        } else {
          console.log("nessuna tabella presente");
        }
      });
    },

    goBack() {
      if (this.from_adapter_list === true) {
        this.$router.push("/home");
      } else {
        this.$emit("click_indietro");
      }
    },
    modificaTabella(tabella) {
      this.$emit("modificaTabella", tabella);
    },
    playQuery() {
      console.log("workorder", this.workorder);

      this.query_sel.query = this.query_sel.query
        .replaceAll("\n", " ")
        .replaceAll("\r", " ")
        .replaceAll("\t", " ");

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "executequery",
          token: localStorage.user_token,
          // query: this.query_sel.query.length != 0 ? this.query_sel.query : null,
          id_tabella_statistica: this.tabella_sel.id_query,
          params:
            this.workorder != undefined
              ? [
                  {
                    label: "@0",
                    value: this.workorder.id_articolo,
                  },
                  {
                    label: "@1",
                    value: this.workorder.id_ciclo_fasi,
                  },
                  {
                    label: "@2",
                    value: this.workorder.id_commessa,
                  },
                  {
                    label: "@3",
                    value: this.workorder.id_commessa_dettaglio,
                  },
                  {
                    label: "@4",
                    value: this.workorder.id_commessa_tempi,
                  },
                  {
                    label: "@5",
                    value: this.workorder.id_disegno,
                  },
                  {
                    label: "@6",
                    value: this.workorder.id_fase,
                  },
                  {
                    label: "@7",
                    value: this.workorder.id_macchina,
                  },
                  {
                    label: "@8",
                    value: this.workorder.id_personale,
                  },
                  {
                    label: "@9",
                    value: this.workorder.ora_start,
                  },
                ]
              : null,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log("playquery");
          if (res.status === 200) {
            this.result_query = res.data.result;
            console.log("Risultato query", this.result_query);
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>